<h3>Instrucciones Test</h3>

<div *ngIf="!instructionSelected" class="card p-30">
  <div #text1></div>
  <div class="col-12">
    <button class="btn btn-info btn-rounded waves-effect pull-right m-t-20" (click)="editInstructions()">Editar</button>
  </div>
</div>

<div *ngIf="instructionSelected" class="row justify-content-center">
    <div class="NgxEditor__Wrapper p-20 m-b-40 col-12">
        <ngx-editor-menu [editor]="editor"> </ngx-editor-menu>
        <ngx-editor
          [editor]="editor"
          [(ngModel)]="html"
          [placeholder]="'Escriba su texto...'"
        ></ngx-editor>
        <button class="btn btn-success btn-rounded waves-effect pull-right m-t-20" (click)="saveHtml()">Guardar</button>
    </div>
</div>

<h3>Instrucciones simulación</h3>

<div *ngIf="!instruction3Selected" class="card p-30">
  <div #text3></div>
  <div class="col-12">
    <button class="btn btn-info btn-rounded waves-effect pull-right m-t-20" (click)="editInstructions3()">Editar</button>
  </div>
</div>

<div *ngIf="instruction3Selected" class="row justify-content-center">
    <div class="NgxEditor__Wrapper p-20 m-b-40 col-12">
        <ngx-editor-menu [editor]="editor3"> </ngx-editor-menu>
        <ngx-editor
          [editor]="editor3"
          [(ngModel)]="html3"
          [placeholder]="'Escriba su texto...'"
        ></ngx-editor>
        <button class="btn btn-success btn-rounded waves-effect pull-right m-t-20" (click)="saveHtml3()">Guardar</button>
    </div>
</div>

<h3>Introducción al reporte</h3>

<div *ngIf="!reportSelected" class="card p-30">
  <div #text2></div>
  <div class="col-12">
    <button class="btn btn-info btn-rounded waves-effect pull-right m-t-20" (click)="editReport()">Editar</button>
  </div>
</div>

<div *ngIf="reportSelected" class="row justify-content-center">
  <div class="NgxEditor__Wrapper p-20 m-b-40 col-12">
      <ngx-editor-menu [editor]="editor2"> </ngx-editor-menu>
      <ngx-editor
        [editor]="editor2"
        [(ngModel)]="html2"

        [placeholder]="'Escriba su texto...'"
      ></ngx-editor>
      <button class="btn btn-success btn-rounded waves-effect pull-right m-t-20" (click)="saveHtml2()">Guardar</button>
  </div>
</div>